import ITranslation from "../../utils/types/translation";

const translationsEN: ITranslation = {
	Accessory: "Accessory",
	AfterDossierCompletion: "Dossier volledig",
	AfterInstallation: "To be payed after installation",
	AfterMeasurement: "Na opmenting",
	AfterSales: "After sales",
	AfterSalesVPlan: "After Sales vPlan",
	Appliance: "Appliance",
	ArticleAccessory: "Article-Accessory",
	ArticleAppliance: "Article-Appliance",
	ArticleFurniture: "Article-Furniture",
	ArticleOther: "Article-Other",
	ArticlePlumbing: "Article-Plumbing",
	ArticleWorktops: "Article-Worktop",
	AwaitingReminder: "Awaiting reminder",
	Closed: "Closed",
	Communication: "Communication",
	Contacts: "Contacts",
	Delivered: "Delivered",
	Delivery: "Delivery",
	Deposit: "Deposit",
	Documents: "Documents",
	Email: "Email",
	Error: "Error",
	Furniture: "Furniture",
	General: "General",
	Green: "Green",
	Illness: "Illness",
	Installation: "Installation",
	Invoicing: "Invoicing",
	New: "New",
	None: "Geen",
	NotApplicable: "N.A.",
	Now: "Nu",
	OnDelivery: "To be payed at delivery",
	Orange: "Orange",
	OrderExternal: "Order External",
	Ordered: "Ordered",
	OrderedProduction: "Ordered Production",
	Other: "Other",
	PhotosFilesVPlan: "Photos-Files vPlan",
	Picked: "Picked",
	Plumbing: "Plumbing",
	ReadyForExecution: "Ready for execution",
	Red: "Red",
	ReminderError: "Reminder error",
	Sending: "Sending",
	SendingReminder: "Sending reminder",
	Sent: "Sent",
	Service: "Service",
	Vacation: "Vacation",
	Vat0: "0%",
	Vat21: "21%",
	Vat6: "6%",
	Worktop: "Worktop",
	Worktops: "Worktops",
	absenceReason: "Reason of absence",
	absent: "Absent",
	actions: "Actions",
	active: "Active",
	add: "Add",
	addRemark: "Add remark",
	add_at_least_one: "Please add at lease 1 {{entity}}.",
	address: "Address",
	aftersales: "After sales",
	amount: "€ Amount",
	amountExclVat: "€ Amount excl. VAT",
	amountInclVat: "€ Amount incl. VAT",
	article: "Article",
	articles: "Articles",
	ask_save: "There are still unsaved changes. Do you wish to save them?",
	assign: "Assign",
	assignee: "Assignee",
	back: "Back",
	barcode: "Barcode (EAN or UPC)",
	binNumber: "Bin number",
	body: "Body",
	brand: "Brand",
	brands: "Merken",
	by: "By",
	calendar: {
		today: "TODAY"
	},
	cancel: "Cancel",
	cancelling: "Cancel",
	changeFutureTasks: "Change future tasks",
	changeFutureTasksQuestion: "Do you want this lead-colleague combination to be applied in all future tasks?",
	checkDate: "Checked",
	checkInAtWork: "CheckIN@Work",
	close: "Close",
	closed: "Closed",
	code: "Code",
	colleague: "Colleague",
	color: "Color",
	communication: "Communication",
	communicationTemplates: "Communication Templates",
	communicationTemplatesSplitted: "Communication Templates",
	companies: "Companies",
	company: "Company",
	complete: "Complete",
	confirmChangeFixedDate: "This is a task with fixed date. Are you sure you want to move this task?",
	confirmDelivery: "Are you sure you want to set 1 item of this article delivered?",
	confirmDeliveryTitle: "Confirm delivery",
	confirmLeave: "You have unsaved data, are you sure you want to leave without saving your changes?",
	confirmPassonPickedDate: "Do you wish to pass this date to all the articles?",
	confirm_content: "Are you sure you wish to {{action}} this record?",
	confirm_title: "Confirm {{action}}",
	constructionYard: "Construction Yard",
	constructionYardContact1: "Construction yard contact 1",
	constructionYardContact2: "Construction yard contact 2",
	constructionYards: "Construction Yards",
	contactName: "Contact name",
	contactTypes: "Contact types",
	contacts: "Contacts",
	contractor: "Contractor",
	contractors: "Contractors",
	copy: "Copy",
	copyDossier: "Copy dossier",
	count: "Count",
	country: "Country",
	createNew: "This <1 /> is not found.<3 />Do you wish to create a new one?",
	createNewTask: "Create new task",
	createPurchaseOrders: "Create purchase orders",
	created: "Created",
	createdBy: "Created by",
	createdOn: "Created on",
	cupboards: "Cupboards",
	currentWeek: "This Week",
	customer: "Customer",
	customers: "Customers",
	date: "Date",
	dateinput: {
		increment: "Increase value",
		decrement: "Decrease value"
	},
	datepicker: {
		toggleCalendar: "Toggle calendar"
	},
	day: "day",
	deliverDate: "Delivered",
	delivered: "Delivered",
	deliveries: "Deliveries",
	deliveryDate: "Delivery date",
	deliveryWeek: "Deliveryweek",
	depositAmountExclVat: "Deposit amount excl. VAT",
	depositInvoiced: "Deposit invoiced",
	depositPayed: "Deposit payed",
	description: "Description",
	details: "Details",
	discount: "Discount",
	displayedUsers: "Displayed users",
	documents: "Documents",
	dossier: "Dossier",
	dossierCannotBeDeleted: "This dossier cannot be delete. Please first clear the following items from this dossier:",
	dossierContact1: "Dossier contact 1",
	dossierContact2: "Dossier contact 2",
	dossierCopied: "Dossier copied",
	dossierDescription: "Dossier description",
	dossierManagement: "Dossier management",
	dossierManager: "Dossier manager",
	dossierMustBeComplete: "Dossier must be complete before you can perform this action.",
	dossierNumber: "Dossier number",
	dossierViewCheck: "Only show dossiers with to be planned tasks.",
	downloadTradeplaceFile: "Download Tradeplace file",
	eanInformation: "EAN Information",
	edit: "Edit",
	email: "Email",
	email1: "Email 1",
	email2: "Email 2",
	en: "English",
	error: "Error",
	errorInvoicing: "Invoicing error. If 'Now' is selected you must enter an amount greater than zero.",
	errors: {
		server_error: 'The server returned a "{{statuscode}}" response.',
		error_duplicate: "This entity allready exists",
		error_dbconcurrency: "This record is changed or deleted by someone else. Please refresh.",
		error_entityused: "This entity is still used in the application. If you don't want to see it anymore, please deactivate it",
		error_constraintfailure: "A database contstraint prevented this action",
		error_sqlconnection: "Unable to make a database connection",
		error_sqlgeneral: "A database error occured",
		error_validation: "The server side validation failed",
		error_connection: "Unable to make an external connection",
		error_argumentnull: "An {{argument}} was empty in the serverside",
		error_productwrongreplacement: "A product cannot be its own replacement",
		error_general: "An error on the servers side has occured",
		error_server_validation: "Server validation error",
		error_idfilledin: "The ID cannot be filled in while adding an entity",
		error_routeiddoesnotmatch: "The ID in the route does not match the ID in the entity",
		error_idnotfilledin: "The ID must be filled in when deleteing",
		error_toomanyresults: "Too many result",
		error_nofile: "No file provided",
		error_nobarcodeorsearch: "No barcode or search provided",
		error_constructionyardexistsbutnotactive: "Construnction yard found, but it is not active",
		not_authenticated: "You are not logged in at the server",
		not_found: "The server did not find a result",
		forbidden: "You don't have access to this part of the server application"
	},
	estimatedSellerMargin: "Estimated seller margin (%)",
	executedBy: "Executed by",
	exportExcel: "Export Excel",
	extraInfo: "Extra info",
	extraInformation: "Additional information",
	fetchEanInformation: "Fetch EAN information",
	file: "File",
	fill_in_correct_date_values: "Please fill in correct values for date and time fields. (Start > Stop)",
	fill_in_correct_format: "Please fill in a correct value for the field '{{field}}'. Ex: '{{example}}'.",
	fill_in_required_field: "Please fill in the required field '{{field}}'.",
	fill_in_required_field_absent: "Please fill in a lead or colleague as person to be absent.",
	fill_in_required_field_absent_date: "Please fill in a start and stop date for the given absence",
	fill_in_required_field_for_fixedDate: "Please fill in the field '{{field}}' to set a fixed date.",
	fill_in_required_field_for_planned: "Please fill in the field '{{field}}' to set a task as planned.",
	finished: "Finished",
	firstName: "First name",
	firstOrderDate: "First orderdate",
	fixedDate: "Fixed date",
	fixedDeliveryDate: "Fixed delivery date",
	floor: "Floor",
	friday: "Friday",
	fullDescriptionVat0: "Co-contractor - 0%",
	fullDescriptionVat21: "New building project - 21%",
	fullDescriptionVat6: "Renovation - 6%",
	fullName: "Full name",
	gamma: "Gamma",
	general: "General",
	grid: {
		noRecords: "No records available",
		groupPanelEmpty: "Drag a column header and drop it here to group by that column",
		filterClearButton: "Clear",
		filterSubmitButton: "Filter",
		filterTitle: "Filter",
		sortAscending: "Sort Ascending",
		sortDescending: "Sort Descending",
		pagerItemsPerPage: "items per page",
		pagerInfo: "{0} - {1} of {2} items",
		pagerFirstPage: "Go to the first page",
		pagerPreviousPage: "Go to the previous page",
		pagerNextPage: "Go to the next page",
		pagerLastPage: "Go to the last page",
		pagerPage: "Page",
		pagerOf: "of",
		filterEqOperator: "Is equal to",
		filterNotEqOperator: "Is not equal to",
		filterIsNullOperator: "Is null",
		filterIsNotNullOperator: "Is not null",
		filterIsEmptyOperator: "Is empty",
		filterIsNotEmptyOperator: "Is not empty",
		filterStartsWithOperator: "Starts with",
		filterContainsOperator: "Contains",
		filterNotContainsOperator: "Does not contain",
		filterEndsWithOperator: "Ends with",
		filterGteOperator: "Is greater than or equal to",
		filterGtOperator: "Is greater than",
		filterLteOperator: "Is less than or equal to",
		filterLtOperator: "Is less than",
		filterIsTrue: "Yes",
		filterIsFalse: "No",
		filterBooleanAll: "(All)",
		filterAfterOrEqualOperator: "Is after or equal to",
		filterAfterOperator: "Is after",
		filterBeforeOperator: "Is before",
		filterBeforeOrEqualOperator: "Is before or equal to",
		filterAndLogic: "And",
		filterOrLogic: "Or"
	},
	group: "Group",
	hasSimpleAccess: "Simple Access?",
	help: "Help",
	home: "Home",
	installationWeek: "Installation week",
	installer: "Installer",
	invoiceDepositOn: "Invoice deposit on",
	invoiceSelected: "Invoice selected lines",
	invoiced: "Invoiced",
	invoicing: "Invoicing",
	isLiftNeeded: "Lift needed?",
	labelPrinted: "The printing of your label has been requested",
	labelsPrinted: "The printing of yaur labels has been requested",
	language: "Language",
	lastName: "Last name",
	lastUpdated: "Last update",
	lastUploadedBy: "Last uploaded by",
	lastUploadedDate: "Last uploaded on",
	lead: "Lead",
	leadInstaller: "Lead installer",
	lineTotal: "Line total",
	lineTotalExcl: "excl. VAT (incl. discount)",
	lineTotalIncl: "incl. VAT (incl. discount)",
	lineTotalVat: "VAT € (incl. discount)",
	loggedBy: "Logged by",
	logout: "Log out",
	manufacturer: "Manufacturer",
	Margin: "Margin",
	marginStatus: "Margin status",
	MarginNotYetDeterminable: "Margin not yet determinable",
	MarginToBeInvestigated: "Margin to be investigated",
	MarginValidated: "Margin validated",
	marginAfterAccountingAndValidation: "Margin after accounting/validation (%)",
	marginAmountBasedOnAccounting: "Margin amount based on accounting (€)",
	masterData: "Master data",
	material: "Material",
	measured: "Measured",
	measurement: "Measurement",
	modelNumber: "Model number",
	monday: "Monday",
	month: "month",
	multiviewcalendar: {
		prevView: "Navigate to previous view",
		nextView: "Navigate to next view"
	},
	municipality: "Municipality",
	name: "Name",
	netPrice: "Net price",
	newDossierNumber: "New dossier number",
	next: "Next",
	nextWeek: "Next Week",
	nl: "Dutch",
	no: "No",
	notFound: "{{entity}} not found",
	number: "Number",
	off: "Off",
	ok: "Ok",
	on: "On",
	openServiceItems: "Open after sales items",
	or: "or",
	orderDate: "Ordered",
	orderViaEMail: "Order via email",
	ourCustomerNumber: "Our customer number",
	parking: "Parking",
	passOnPickedDate: "Pass on date",
	payed: "Payed",
	pending_changes: "Changes",
	permission: "Permission",
	permissions: {
		RolesRead: "Read",
		RolesAdd: "Add",
		RolesUpdate: "Update",
		RolesDelete: "Delete",
		UsersRead: "Read",
		UsersAdd: "Add",
		UsersUpdate: "Update",
		UsersDelete: "Delete",
		SuppliersRead: "Read",
		SuppliersAdd: "Add",
		SuppliersUpdate: "Update",
		SuppliersDelete: "Delete",
		ProductsRead: "Read",
		ProductsAdd: "Add",
		ProductsUpdate: "Update",
		ProductsDelete: "Delete",
		CustomersRead: "Read",
		CustomersAdd: "Add",
		CustomersUpdate: "Update",
		CustomersDelete: "Delete",
		ContractorsRead: "Read",
		ContractorsAdd: "Add",
		ContractorsUpdate: "Update",
		ContractorsDelete: "Delete",
		ConstructionYardsRead: "Read",
		ConstructionYardsAdd: "Add",
		ConstructionYardsUpdate: "Update",
		ConstructionYardsDelete: "Delete",
		ProjectsRead: "Read",
		ProjectsAdd: "Add",
		ProjectsUpdate: "Update",
		ProjectsDelete: "Delete",
		BrandsRead: "Read",
		BrandsAdd: "Add",
		BrandsUpdate: "Update",
		BrandsDelete: "Delete",
		ProductTypesRead: "Read",
		ProductTypesAdd: "Add",
		ProductTypesUpdate: "Update",
		ProductTypesDelete: "Delete",
		ShopsRead: "Read",
		ShopsAdd: "Add",
		ShopsUpdate: "Update",
		ShopsDelete: "Delete",
		CommunicationTemplatesRead: "Read",
		CommunicationTemplatesAdd: "Add",
		CommunicationTemplatesUpdate: "Update",
		CommunicationTemplatesDelete: "Delete",
		ContactTypesRead: "Read",
		ContactTypesAdd: "Add",
		ContactTypesUpdate: "Update",
		ContactTypesDelete: "Delete",
		DossiersRead: "Read",
		DossiersAdd: "Add",
		DossiersUpdate: "Update",
		DossiersDelete: "Delete",
		StockRead: "Read",
		StockAdd: "Add",
		ProcurementView: "Procurement view",
		PlanningView: "Planning view",
		WarehouseView: "Warehouse view",
		InvoicingView: "Invoicing view",
		InvoicingMarginUpdate: "Margin update",
		InvoicingMarginView: "Margin view",
		PrintLabels: "Allowed",
		Settings: "Allowed",
		Home: "Allowed",
		TeamsRead: "Read",
		TeamsAdd: "Add",
		TeamsUpdate: "Update",
		TeamsDelete: "Delete",
		SettingsRead: "Read",
		SettingsUpdate: "Update"
	},
	phone: "Phone",
	phone1: "Phone 1",
	phone2: "Phone 2",
	photos: "photos",
	pickDate: "Picked",
	picked: "Picked",
	pickedDateChanged: "Picked date has changed",
	pickings: "Pickings",
	planned: "Planned",
	planning: "Planning",
	planningManagementDelivery: "Planning management - Delivery",
	planningManagementInstallation: "Planning management - Installation",
	planningManagementService: "Planning management - Service",
	pleaseSaveFirst: "You can only do this action for saved dossiers.<1 />Please save you work before performing this action.",
	please_calculate: "Please run the price calculation.",
	pokNumber: "POKNr.",
	postalCode: "Postal Code",
	prevWeek: "Previous Week",
	previous: "Previous",
	print: "Print",
	printLabels: "Print labels",
	privacy: "Privacy",
	procurement: "Procurement",
	product: "Product",
	productTypes: "Types",
	productionWeek: "Production week",
	products: "Products",
	project: "Project",
	projects: "Projects",
	province: "Province",
	purchasePriceExclVat: "€ Purchase/piece price excl. VAT",
	putArticleInStock: "Do you which to place the removed article in stock?",
	readyForPicking: "Ready for picking",
	related: "Related To",
	relatedToArticlePhase: "Article Phase",
	remark: "Remark",
	remarks: "Remarks",
	reminderBody: "Reminder",
	reminderDate: "Send reminder on",
	remove: "Remove",
	replacementProduct: "Replacement Product",
	replacement_product_cannot_be_the_same: "The replacement product cannot be the same.",
	resentOrderEmail: "Resent order mail",
	reset: "Reset",
	role: "Role",
	roles: "Roles",
	runningDossiers: "Running dossiers",
	salesPrice: "Sales price",
	salesPriceExclVat: "€ Sales price excl. VAT",
	salesPriceInclVat: "€ Sales price incl. VAT",
	salesRep: "Sales representative",
	saturday: "Saturday",
	save: "Save",
	scanLocation: "Scan location",
	schedule: "Schedule",
	searchByPok: "Search by POKnr",
	searchDossierNumber: "Search dossiernummer",
	security: "Security",
	selectAll: "Select all",
	selectDossierMessage: "Select a dossier to view tasks.",
	select_at_least_one: "Please select at least one {{entity}}.",
	sellingDate: "Selling date",
	sendToVPlan: "Send to vPlan",
	sequenceNumber: "Sequence number",
	setPurchaseOrdersChecked: "Set purchase orders checked",
	settings: "Settings",
	shop: "Shop",
	shops: "Shops",
	show: "Show",
	showCompletedTasks: "Show completed tasks",
	showNewDossier: "Do you wish to navigate to the new dossier?",
	soldOn: "Sold on",
	startDate: "Start date",
	startSequenceNumberDossier: "Start at this sequence number when new task via scheduling",
	startTime: "Start time",
	status: "Status",
	stock: "Stock",
	stockMovement: "Stock movement",
	stopDate: "Stop date",
	stopTime: "Stop time",
	street: "Street",
	subject: "Subject",
	success: "Success",
	supplier: "Supplier",
	suppliers: "Suppliers",
	swap: "Swap",
	switchcompany: "Switch company",
	task: "Task",
	taskComplete: "Complete",
	taskDescription: "Task description",
	taskPhotos: "Task photos",
	tasks: "Tasks",
	team: "Team",
	teams: "Teams",
	template: "Template",
	theseAreTheServerErrorMessages: "These are the server validation errors:",
	thursday: "Thursday",
	time: "Time",
	timepicker: {
		cancel: "Cancel",
		now: "NOW",
		selectNow: "Select Now",
		set: "Set",
		toggleClock: "Toggle Clock",
		toggleTimeSelector: "Toggle TimeSelector"
	},
	to: "To",
	toBeAsked: "To be asked",
	todaysTasks: "Today's tasks",
	totalExclVat: "Total excl. VAT: € ",
	totalInclVat: "Total incl. VAT: € ",
	totalVat: "Total VAT: € ",
	tuesday: "Tuesday",
	type: "Type",
	unable_to_display: "Unable to display. Download <3>here</3>.",
	unit: "Unit",
	unitPrice: "Unit price",
	upload: {
		cancel: "Cancel",
		clearSelectedFiles: "Clear",
		dropFilesHere: "Drop files here to upload",
		headerStatusUploaded: "Done",
		headerStatusUploading: "Uploading...",
		invalidFileExtension: "File type not allowed.",
		invalidFiles: "Invalid file(s). Please check file upload requirements.",
		invalidMaxFileSize: "File size too large.",
		invalidMinFileSize: "File size too small.",
		remove: "Remove",
		retry: "Retry",
		select: "Select files...",
		uploadSelectedFiles: "Upload",
		total: "Total",
		files: "files"
	},
	user: "User",
	users: "Users",
	vat: "VAT",
	vatNumber: "VAT number",
	vatOnDeposit: "VAt% on deposit",
	warehouse: "Warehouse",
	wednesday: "Wednesday",
	welcome_message: "Welcome ",
	work: "Work",
	writeOut: "Write Out",
	writtenOut: "Written out",
	year: "year",
	yes: "Yes",
	yourProfile: "Your profile",
	yourRemarks: "Your remarks",
	siteManager: "Site manager",
	typeDossierSale: "Type dossier sales",
	typeDossierProduction: "Type dossier production",
	complexityScore: "Complexity WorkPreparation",
	studioScore: "Studio elements",
	PlasticMaterialStock : "K1: Plastic material stock",
    NonStockInCatalog : "K2: Non-stock in catalog",
    NonStockNotInCatalog : "K3: Non-stock not in catalog",
    Veneer : "K4: Veneer (varnish only)",
    Solid : "K5: Solid",
    LacquerIntern : "K6: Lacquer intern",
    LacquerExtern : "K7: Lacquer extern",
    ShowroomKitchen : "K8: Specials (inc. Showroom kitchen)",
	NewBuildAppartments : "T1: Newbuild appartments",
    NewBuildHouseContractor : "T2: Newbuild house contractor",
    PrivateIndividualsNewBuild : "T3: Private new build",
    PrivateIndividualsRenovation : "T4: Private technical aspects unconfirmed (this also applies to any kitchen starting at 25k)",
    Specials : "T5: Specials (including large projects, showroom kitchens, and anything involving additional work—excluding cabinet assembly) ",
    ServiceAppliances2People : "T6: Service & appliances 2 people",
    ServiceAppliances1Person : "T7: Service & appliances 1 person",
	PickupShowroom: "T8: Pickup showroom",
	MeasuredDuringSurvey : "S-O: In stock, measured during survey",
    MeasuredDuringSurveyInAbsentia : "S-O-PL: In stock, measured during survey, in absentia",
    MeasuredAfterInstallation : "S-NP: In stock, measured after installation",
    MeasuredAfterInstallationInAbsentia : "S-NP-PL: In stock,  measured after installation, in absentia",
    MeasuredDuringSurveyNotInStock : "N-O: Not in stock, measured during survey",
    MeasuredDuringSurveyNotInStockInAbsentia : "N-O-PL: Not in stock, measured during survey, in absentia",
    MeasuredAfterInstallationNotInStock : "N-NP: Not in stock, measured after installation",
    MeasuredAfterInstallationNotInStockInAbsentia : "N-NP-PL: Not in stock, measured after installation, in absentia",
    MeasuredDuringSurveyExtern : "EX-O: Externally purchased, measured during survey",
    MeasuredDuringSurveyExternInAbsentia : "EX-O-PL: Externally purchased, measured during survey,in absentia",
    MeasuredAfterInstallationExtern : "EX-NP: Externally purchased, measured after installation",
    MeasuredAfterInstallationExternInAbsentia : "EX-NP-PL: Externally purchased, measured after installation, in absentia",
	stoneCategorization: "Stone categorization",
	lacqueringComponent: "Lacquering componenets",
	access: "Access"
};

export default translationsEN;
